// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2ucS_","header":"MergedInvoice_header__2cIQX"};